import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  ProjectLabel,
  ProjectLabelItem,
} from "../../types/interface/ProjectLabel.interface";
import AxiosInstance from "../../Service/AxiosInstance";
import { toast } from "react-toastify";

const initialState: ProjectLabel = {
  labels: [],
  loading: false,
  error: null,
  searchData: [],
  projectLabelDetails: null,
};

export const fetchProjectLabels = createAsyncThunk(
  "projectLabel/fetchProjectLabels",
  async (projectId: string, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/GetAll?projectId=${projectId}`
      );
      return response.data;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        //toast.error(error.response.data);
      } else {
        //toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchProjectLabelById = createAsyncThunk(
  "projectLabel/fetchProjectLabelById",
  async (labelId: string, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/GetById?projectlabelId=${labelId}`
      );
      return response.data;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        //toast.error(error.response.data);
      } else {
        //toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// export const addProjectLabels = createAsyncThunk(
//   "projectLabel/fetchProjectLabels",
//   async (projectId: string) => {
//     const response = await AxiosInstance.get(
//       `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/GetAll?projectId=${projectId}`
//     );
//     return response.data;
//   }
// );

export const addProjectLabels = createAsyncThunk(
  "projectLabel/addProjectLabel",
  async (data: ProjectLabelItem, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/Add`,
        data
      );
      return response.data;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        toast.error(error.response.data);
      } else {
        toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// New function for search data
export const getSearchData = createAsyncThunk(
  "projectLabel/getSearchData",
  async (search: string, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/Search/GetSearchData?search=${search}`
      );
      return response.data;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        toast.error(error.response.data);
      } else {
        toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const editProjectLabel = createAsyncThunk(
  "projectLabel/editProjectLabel",
  async (data: ProjectLabelItem, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/Update`,
        data
      );
      return response.data;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        toast.error(error.response.data);
      } else {
        toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteProjectLabel = createAsyncThunk(
  "projectLabel/delete",
  async (labelId: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/Delete?projectlabelId=${labelId}`
      );

      return labelId;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        toast.error(error.response.data);
      } else {
        toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const disableProjectLabel = createAsyncThunk(
  "projectLabel/disable",
  async (labelId: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectLabel/Disable?projectlabelId=${labelId}`
      );

      return response.data;
    } catch (error: any) {
      if (typeof error.response.data == "string") {
        toast.error(error.response.data);
      } else {
        toast.error(error.response.data.detail);
      }
      return rejectWithValue(error.response.data);
    }
  }
);



const projectLabelSlice = createSlice({
  name: "projectLabel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectLabels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectLabels.fulfilled, (state, action) => {
        state.loading = false;
        state.labels = action.payload;
      })
      .addCase(fetchProjectLabels.rejected, (state, action) => {
        state.labels = [];
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      })

      .addCase(fetchProjectLabelById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectLabelById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectLabelDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchProjectLabelById.rejected, (state, action) => {
        state.labels = [];
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      })

      // Save project label
      .addCase(addProjectLabels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        addProjectLabels.fulfilled,
        (state, action: PayloadAction<ProjectLabelItem>) => {
          state.loading = false;
          state.labels.push(action.payload);
        }
      )
      .addCase(addProjectLabels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to save the label";
      })

      // Handle search data response
      .addCase(getSearchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSearchData.fulfilled, (state, action) => {
        state.loading = false;
        // Update with search results, depending on how you want to handle them
        // For example, assuming you want to merge it with the existing labels:
        state.searchData = action.payload;
      })
      .addCase(getSearchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch search data";
      })
      // Update project label
      .addCase(editProjectLabel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        editProjectLabel.fulfilled,
        (state, action: PayloadAction<ProjectLabelItem>) => {
          state.loading = false;
          let index = state.labels.findIndex((x) => x.id === action.payload.id);
          if (index !== -1) {
            state.labels[index] = action.payload;
          }
          //update the state here after edit
          //state.labels.push(action.payload);
        }
      )
      .addCase(editProjectLabel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to save the label";
      })

      .addCase(deleteProjectLabel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProjectLabel.fulfilled, (state, action) => {
        let index = state.labels.findIndex((x) => x.id === action.payload);
        state.labels.splice(index, 1);
        state.loading = false;
        //state.labels = action.payload;
      })
      .addCase(deleteProjectLabel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export default projectLabelSlice.reducer;
